<template>
  <v-card class="elevation-5">
    <v-row class="px-4">
      <slot name="searchFields"/>
      <v-col v-if="properties.submitBtn" cols="12" class="pt-1">
        <v-btn
            block
            color=      "primary"
            :disabled=  "properties.loading || properties.submitBtn.disabled"
            @click=     "properties.getData"
        >
          {{$t('field.SEARCH')}}
        </v-btn>
      </v-col>
    </v-row>
    <v-card-title class="pb-0 pt-10">
      <v-text-field
          v-if="properties.items.length > 0 && !properties.hideFreeSearch"
          hide-details
          outlined
          reverse
          dense
          :label=       "$t('field.FREE_SEARCH')"
          v-model=      "search"
          append-icon=  "mdi-magnify"
      />
    </v-card-title>
    <v-pagination
        v-if=            "pageCount > 1"
        :value=         "paginationModel"
        :length=        "pageCount"
        total-visible=  "20"
        :disabled=      "properties.loading"
        @input=         "onPaginationInput"
    />
    <v-data-table
        hide-default-footer
        multi-sort
        dense
        dir=                "rtl"
        :items=             "properties.items"
        :search=            "searchTrigger"
        :headers=           "properties.headers"
        :loading=           "properties.loading"
        :sort-by=           "properties.sortBy"
        :sort-desc=         "properties.sortDir"
        :page=              "dataTablePage"
        :loading-text=      "$t('field.Loading')"
        :no-data-text=      "$t('field.NoData')"
        :items-per-page=    "dataTableItemsPerPage"
        :no-results-text=   "$t('field.NotFound')"
        :mobile-breakpoint= "1000"
        @pagination=        "onTablePagination"
    >
      <template v-for="field in properties.dynamicFieldsSlots" v-slot:[`item.${field}`] = '{ item }'>
        <slot :name='field' :item='item'/>
      </template>
    </v-data-table>
    <v-pagination
        v-if=            "pageCount > 1"
        :value=         "paginationModel"
        :length=        "pageCount"
        total-visible=  "20"
        :disabled=      "properties.loading"
        @input=         "onPaginationInput"
    />
  </v-card>
</template>
<script>
  export default {
    props: { properties: Object },
    computed: {
      pageCount() {
        if (this.properties.serverPaginate) {
          const n = parseInt(String(this.properties.serverPaginationLength || 1), 10) || 1
          return n > 1 ? n : 0
        }
        return Math.ceil(this.filteredItemsCount / this.properties.itemsPerPage)
      },
      searchTrigger() { return this.search.length < 3 ? '' : this.search },
      paginationModel() {
        if (this.properties.serverPaginate) {
          return parseInt(String(this.properties.serverPage || 1), 10) || 1
        }
        return this.page
      },
      dataTableItemsPerPage() {
        return this.properties.itemsPerPage
      },
      dataTablePage() {
        return this.properties.serverPaginate ? 1 : this.page
      },
    },
    data() {
      return {
        page:               1,
        search:             '',
        filteredItemsCount: 0
      }
    },
    watch: {
      "properties.serverPage": {
        handler(v) {
          if (!this.properties.serverPaginate) return
          const p = parseInt(String(v || 1), 10) || 1
          if (this.page !== p) this.page = p
        },
        immediate: true,
      },
      "properties.resetPageKey"() {
        this.page = 1
      },
    },
    methods: {
      onPaginationInput(p) {
        if (this.properties.serverPaginate && this.properties.onServerPageChange) {
          this.properties.onServerPageChange(p)
          return
        }
        this.page = p
      },
      onTablePagination(pagination) {
        this.filteredItemsCount = pagination.itemsLength
        if (!this.properties.serverPaginate && pagination.page != null) {
          this.page = pagination.page
        }
      },
    }
  }
</script>
<style>
  .v-data-table-header-mobile {
    display: none;
  }
</style>
